var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentScroll,_vm._b({ref:"vuePerfectScrollbarComponentCustom",tag:"component",staticClass:"email-user-list scroll-area overflow-auto"},'component',_vm.componentScrollSettings,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }